import { processRequest } from "@api/config";
import { tariffAPI } from "@api/tariff";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const useBalanceQuery = () =>
	useAuthQuery({
		queryKey: [QUERY_KEYS.MODEL_BALANCE],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_MODEL_BALANCE,
				request: (token) => tariffAPI.getModelBalanceAsync({ token }),
			});

			return data.balance;
		},
	});
